import type { Dict } from '../i18n';

/* English text is the key (see ../i18n.ts). A new UI text needs an entry in de.ts, uk.ts and pl.ts. */
const dict: Dict = {
  "Loading…": "Завантаження…",
  "Switch project": "Змінити проект",
  "All Projects": "Усі проекти",
  "Search": "Пошук",
  "No matching project": "Немає відповідного проекту",
  "Switch team": "Змінити команду",
  "No team": "Без команди",
  "All teams…": "Усі команди…",
  "Recently visited:": "Нещодавно переглянуті:",
  "Teams": "Команди",
  "My View": "Мій огляд",
  "View Issues": "Задачі",
  "Report Issue": "Створити задачу",
  "Change Log": "Журнал змін",
  "Roadmap": "План розвитку",
  "Summary": "Тема",
  "Summary|page": "Підсумок",
  "Manage": "Керування",
  "My Account": "Мій обліковий запис",
  "RSS": "RSS",
  "Logout": "Вийти",
  "Expand": "Розгорнути",
  "Collapse": "Згорнути",
  "Expand sidebar": "Розгорнути бічну панель",
  "Collapse sidebar": "Згорнути бічну панель",
  "Scroll to top": "Прокрутити на початок",
  "Scroll to bottom": "Прокрутити в кінець",
  "Access level {level}": "Рівень доступу: {level}",
  "Access level {level} in {project}": "Рівень доступу в {project}: {level}",
  "Issue #": "Задача №",
  "Jump to issue": "Перейти до задачі",
  "Page not found": "Сторінку не знайдено",
  "Back to My View": "Назад до «Мій огляд»",
  "just now": "щойно",
  "yesterday": "вчора",
  "Unassigned": "Не призначено",
  "Feature": "Функція",
  "Task": "Задача",
  "Bug": "Помилка",
  "Priority": "Пріоритет",
  "Close": "Закрити",
  "Type": "Тип",
  "Key": "№",
  "private": "приватна",
  "pinned": "закріплена",
  "Assignee": "Виконавець",
  "Reporter": "Автор",
  "P": "П",
  "Status": "Статус",
  "Comments": "Коментарі",
  "Attachments": "Вкладення",
  "Updated": "Оновлено",
  "Select all": "Вибрати все",
  "Select {id}": "Вибрати {id}",
  "No issues match your filters.": "Немає задач, що відповідають фільтрам.",
  "None": "Немає",
  "Could not load: {error}": "Не вдалося завантажити: {error}",
  "E-mail on New": "Лист про нову задачу",
  "E-mail on Change of Handler": "Лист про зміну виконавця",
  "E-mail on Feedback": "Лист про запит зворотного зв'язку",
  "E-mail on Resolved": "Лист про вирішення",
  "E-mail on Closed": "Лист про закриття",
  "E-mail on Reopened": "Лист про повторне відкриття",
  "E-mail on Note Added": "Лист про нову нотатку",
  "E-mail on Status Change": "Лист про зміну статусу",
  "E-mail on Priority Change": "Лист про зміну пріоритету",
  "The new passwords do not match.": "Нові паролі не збігаються.",
  "Account updated.": "Обліковий запис оновлено.",
  "Preferences saved.": "Налаштування збережено.",
  "Edit Account": "Редагувати обліковий запис",
  "Username": "Ім'я користувача",
  "Access Level": "Рівень доступу",
  "Real Name": "Справжнє ім'я",
  "E-mail": "Email",
  "Current Password": "Поточний пароль",
  "New Password": "Новий пароль",
  "Confirm Password": "Підтвердіть пароль",
  "Update User": "Оновити",
  "Member since {date} · last visit {visit}": "Учасник з {date} · останній візит {visit}",
  "Assigned Projects": "Призначені проекти",
  "Preferences": "Налаштування",
  "Color issue rows by status": "Розфарбовувати рядки задач за статусом",
  "Dark mode": "Темний режим",
  "Close image preview": "Закрити перегляд зображення",
  "Language": "Мова",
  "Default Project": "Проект за замовчуванням",
  "Notes Sort Order": "Порядок нотаток",
  "Ascending (oldest first)": "За зростанням (спершу старі)",
  "Descending (newest first)": "За спаданням (спершу нові)",
  "Update Prefs": "Зберегти налаштування",
  "Sign-up is by invitation only. Ask a team administrator to invite you.": "Реєстрація лише за запрошенням. Попросіть адміністратора команди запросити вас.",
  "Back to login": "Назад до входу",
  "Join {team}": "Приєднатися до {team}",
  "Create your account": "Створіть обліковий запис",
  "Create an account to accept the invitation.": "Створіть обліковий запис, щоб прийняти запрошення.",
  "(optional)": "(необов'язково)",
  "(at least 8 characters)": "(щонайменше 8 символів)",
  "Team name": "Назва команди",
  "{name}'s team": "Команда {name}",
  "e.g. Acme": "напр. Acme",
  "Creating…": "Створення…",
  "Create account and join": "Створити обліковий запис і приєднатися",
  "Create account": "Створити обліковий запис",
  "Already have an account?": "Вже маєте обліковий запис?",
  "Log in": "Увійти",
  "Go to login": "До входу",
  "This invitation to \"{team}\" has expired or was already used. Ask for a new one.": "Запрошення до «{team}» прострочене або вже використане. Попросіть нове.",
  "{who} invited you to the team \"{team}\". You're logged in as {user}.": "{who} запрошує вас до команди «{team}». Ви увійшли як {user}.",
  "A team administrator": "Адміністратор команди",
  "Joining…": "Приєднання…",
  "Join the team": "Приєднатися до команди",
  "Not you?": "Це не ви?",
  "Log out": "Вийдіть",
  "and use another account.": "і скористайтеся іншим обліковим записом.",
  "Check your e-mail": "Перевірте пошту",
  "If an account uses this address, we sent it a link to choose a new password. The link is valid for 1 hour.": "Якщо ця адреса належить обліковому запису, ми надіслали на неї посилання для зміни пароля. Посилання дійсне 1 годину.",
  "Reset password": "Скидання пароля",
  "Enter the e-mail address of your account.": "Введіть email вашого облікового запису.",
  "Sending…": "Надсилання…",
  "Send reset link": "Надіслати посилання",
  "Choose a new password": "Оберіть новий пароль",
  "The passwords do not match.": "Паролі не збігаються.",
  "Repeat new password": "Повторіть новий пароль",
  "Saving…": "Збереження…",
  "Set password": "Зберегти пароль",
  "Choose your password": "Оберіть свій пароль",
  "Welcome, {name}! Your account was created with a temporary password. Please choose your own before you continue.": "Вітаємо, {name}! Ваш обліковий запис створено з тимчасовим паролем. Будь ласка, оберіть власний пароль, щоб продовжити.",
  "Temporary password": "Тимчасовий пароль",
  "Save and continue": "Зберегти й продовжити",
  "drag cards between columns to change status": "перетягуйте картки між стовпцями, щоб змінити статус",
  "Search this board": "Пошук на дошці",
  "Only my issues": "Лише мої задачі",
  "Show closed (30 days)": "Показати закриті (30 днів)",
  "Clear filters": "Скинути фільтри",
  "Loading board…": "Завантаження дошки…",
  "Showing the first {shown} of {total} issues. Pick a project to narrow the board.": "Показано перші {shown} з {total} задач. Оберіть проект, щоб звузити дошку.",
  "Drop issues here": "Перетягніть задачі сюди",
  "Send a Reminder": "Надіслати нагадування",
  "Jump to Notes": "До нотаток",
  "Jump to History": "До історії",
  "Previous issue in the list": "Попередня задача у списку",
  "Next issue in the list": "Наступна задача у списку",
  "ID": "ID",
  "Project": "Проект",
  "Category": "Категорія",
  "View Status": "Видимість",
  "public": "публічна",
  "Date Submitted": "Дата створення",
  "Last Update": "Останнє оновлення",
  "Assigned To": "Виконавець",
  "Due Date": "Термін",
  "Severity": "Серйозність",
  "Reproducibility": "Відтворюваність",
  "Resolution": "Рішення",
  "Duplicate of": "Дублікат",
  "Product Version": "Версія продукту",
  "Target Version": "Цільова версія",
  "Fixed in Version": "Виправлено у версії",
  "Platform": "Платформа",
  "OS": "ОС",
  "OS Version": "Версія ОС",
  "Product Build": "Збірка продукту",
  "Projection": "Обсяг робіт",
  "ETA": "Оцінка часу",
  "Description": "Опис",
  "Steps To Reproduce": "Кроки для відтворення",
  "Additional Information": "Додаткова інформація",
  "Tags": "Теги",
  "Edit": "Редагувати",
  "Assign To:": "Призначити:",
  "Assign to": "Призначити",
  "[Nobody]": "[Нікому]",
  "[Myself]": "[Собі]",
  "[Reporter]": "[Автору]",
  "Assign to me": "Призначити собі",
  "Change Status To:": "Змінити статус на:",
  "New status": "Новий статус",
  "End Monitor": "Не стежити",
  "Monitor": "Стежити",
  "Unstick": "Відкріпити",
  "Stick": "Закріпити",
  "Clone": "Клонувати",
  "Move": "Перемістити",
  "Delete issue {id} permanently? This cannot be undone.": "Видалити задачу {id} назавжди? Цю дію не можна скасувати.",
  "Delete": "Видалити",
  "Move issue {id}": "Перемістити задачу {id}",
  "Move to project": "Перемістити до проекту",
  "Select a project…": "Оберіть проект…",
  "If the category doesn't exist in the target project, it will be cleared.": "Якщо в цільовому проекті немає такої категорії, її буде очищено.",
  "Cancel": "Скасувати",
  "Move Issues": "Перемістити задачі",
  "To (Ctrl+click for several)": "Кому (Ctrl+клік для кількох)",
  "Reminder": "Нагадування",
  "Please have a look at this issue…": "Будь ласка, подивіться на цю задачу…",
  "The recipients get an e-mail, and the reminder is recorded as a note on the issue.": "Отримувачі отримають лист, а нагадування збережеться як нотатка до задачі.",
  "Send": "Надіслати",
  "Change status of issue {id}": "Зміна статусу задачі {id}",
  "Duplicate of issue #": "Дублікат задачі №",
  "The resolution will be set to \"reopened\".": "Рішення буде змінено на «відкрито знову».",
  "Set status: {status}": "Встановити статус: {status}",
  "Add a note (optional)": "Додати нотатку (необов'язково)",
  "Private": "Приватна",
  "Time tracking (HH:MM)": "Облік часу (ГГ:ХХ)",
  "Detach": "Від'єднати",
  "No tags attached.": "Тегів немає.",
  "(Separate by \",\")": "(Розділяйте «,»)",
  "Attach tags": "Додати теги",
  "Existing tags": "Наявні теги",
  "Attach": "Додати",
  "The file content was not imported from Mantis": "Вміст файлу не було імпортовано з Mantis",
  "file missing": "файл відсутній",
  "Delete {file}?": "Видалити {file}?",
  "Attached Files": "Прикріплені файли",
  "Updating Issue Information": "Редагування задачі",
  "(none)": "(немає)",
  "Update Information": "Зберегти зміни",
  "Relationships": "Зв'язки",
  "Current issue": "Ця задача",
  "Add": "Додати",
  "Delete relationship": "Видалити зв'язок",
  "Delete this relationship?": "Видалити цей зв'язок?",
  "Users monitoring this issue": "Хто стежить за задачею",
  "Remove": "Прибрати",
  "There are no users monitoring this issue.": "Ніхто не стежить за цією задачею.",
  "Add Note": "Додати нотатку",
  "Add a note… (drop files here or paste a screenshot to attach them)": "Додати нотатку… (перетягніть файли сюди або вставте знімок екрана)",
  "Attach files": "Прикріпити файли",
  "Activities": "Активність",
  "Time tracking: {time}": "Облік часу: {time}",
  "There are no notes attached to this issue.": "До цієї задачі немає нотаток.",
  "reminder": "нагадування",
  "edited {when}": "змінено {when}",
  "Save": "Зберегти",
  "Delete this note?": "Видалити цю нотатку?",
  "Make Public": "Зробити публічною",
  "Make Private": "Зробити приватною",
  "Sticky Issue": "Закріплена",
  "Duplicate ID": "ID дубліката",
  "New Issue": "Нова задача",
  "Note Added: {v}": "Додано нотатку: {v}",
  "Note Edited: {v}": "Змінено нотатку: {v}",
  "Note Deleted: {v}": "Видалено нотатку: {v}",
  "Description Updated": "Змінено опис",
  "Additional Information Updated": "Змінено додаткову інформацію",
  "Steps to Reproduce Updated": "Змінено кроки для відтворення",
  "File Added: {v}": "Додано файл: {v}",
  "File Deleted: {v}": "Видалено файл: {v}",
  "Note View State: {v}": "Видимість нотатки: {v}",
  "Issue Monitored: {v}": "Почав стежити: {v}",
  "Issue End Monitor: {v}": "Припинив стежити: {v}",
  "Relationship added": "Додано зв'язок",
  "Relationship deleted": "Видалено зв'язок",
  "Issue cloned": "Задачу клоновано",
  "Issue generated from": "Задачу створено з",
  "Tag Attached: {v}": "Додано тег: {v}",
  "Tag Detached: {v}": "Прибрано тег: {v}",
  "change ({type})": "зміна ({type})",
  "Issue History": "Історія задачі",
  "Date Modified": "Дата зміни",
  "Field": "Поле",
  "Change": "Зміна",
  "List": "Список",
  "Board": "Дошка",
  "{n} selected": "вибрано: {n}",
  "Clear selection": "Очистити вибір",
  "No options": "Немає варіантів",
  "CSV Export": "Експорт у CSV",
  "Search summary, description, notes or #id": "Пошук у назві, описі, нотатках або #id",
  "[None]": "[Нікого]",
  "Monitored by me": "Я стежу",
  "Hide status": "Сховати статус",
  "[none]": "[немає]",
  "resolved and above": "вирішені й вище",
  "closed": "закрита",
  "Reset filter ({n})": "Скинути фільтр ({n})",
  "Saved filters": "Збережені фільтри",
  "Saved filters…": "Збережені фільтри…",
  "shared by {user}": "спільний від {user}",
  "Name for this filter:": "Назва фільтра:",
  "Share this filter with everyone? (Cancel = only me)": "Поділитися фільтром з усіма? (Скасувати = лише для мене)",
  "Save Current Filter": "Зберегти поточний фільтр",
  "Delete this saved filter?": "Видалити цей збережений фільтр?",
  "Delete saved filter": "Видалити збережений фільтр",
  "Delete filter…": "Видалити фільтр…",
  "Viewing Issues ({from} - {to} / {total})": "Задачі ({from} - {to} / {total})",
  "updating…": "оновлення…",
  "Per page": "На сторінці",
  "{ok} updated, {failed} failed: ": "оновлено: {ok}, помилок: {failed}: ",
  "choose…": "оберіть…",
  "choose project…": "оберіть проект…",
  "select a project first": "спершу оберіть проект",
  "version": "версія",
  "Assign": "Призначити",
  "Update Status": "Змінити статус",
  "Resolve": "Вирішити",
  "Update Priority": "Змінити пріоритет",
  "Update Category": "Змінити категорію",
  "Update Target Version": "Змінити цільову версію",
  "Update Fixed in Version": "Змінити «Виправлено у версії»",
  "Update View Status": "Змінити видимість",
  "Note text (required)": "Текст нотатки (обов'язково)",
  "Optional note": "Нотатка (необов'язково)",
  "OK": "OK",
  "Log in to your account.": "Увійдіть до свого облікового запису.",
  "Your password was changed. Log in with the new one.": "Пароль змінено. Увійдіть з новим паролем.",
  "Username or e-mail": "Ім'я користувача або email",
  "Password": "Пароль",
  "Logging in…": "Вхід…",
  "Forgot password?": "Забули пароль?",
  "New here?": "Вперше тут?",
  "Create an account": "Створіть обліковий запис",
  "Team": "Команда",
  "Projects": "Проекти",
  "Custom Fields": "Додаткові поля",
  "New project name": "Назва нового проекту",
  "Create Project": "Створити проект",
  "Create your team's first project to start tracking issues.": "Створіть перший проект команди, щоб почати вести задачі.",
  "Name": "Назва",
  "Parent": "Батьківський",
  "Enabled": "Увімкнено",
  "Issues": "Задачі",
  "read-only": "лише читання",
  "yes": "так",
  "no": "ні",
  "« Projects": "« Проекти",
  "Edit Project: {name}": "Редагування проекту: {name}",
  "Project Name": "Назва проекту",
  "Inherit global categories": "Успадковувати глобальні категорії",
  "Subproject of": "Підпроект проекту",
  "Update Project": "Зберегти проект",
  "Categories": "Категорії",
  "[global]": "[глобальна]",
  "Auto-assign new issues in this category to": "Автоматично призначати нові задачі цієї категорії",
  "(no default assignee)": "(без виконавця за замовчуванням)",
  "Rename category": "Перейменувати категорію",
  "Rename": "Перейменувати",
  "Delete category {name}?": "Видалити категорію {name}?",
  "New category": "Нова категорія",
  "Add Category": "Додати категорію",
  "Versions": "Версії",
  "Version": "Версія",
  "Released": "Випущено",
  "Obsolete": "Застаріла",
  "Date": "Дата",
  "Rename version (also updates issues)": "Перейменувати версію (оновить і задачі)",
  "Delete version {name}?": "Видалити версію {name}?",
  "New version": "Нова версія",
  "released": "випущено",
  "Add Version": "Додати версію",
  "Project Members (access overrides)": "Учасники проекту (окремі права)",
  "No per-project access overrides. Public projects use each member's team access level.": "Окремих прав для проекту немає. Публічні проекти використовують рівень доступу учасника в команді.",
  "user…": "користувач…",
  "Add / Update": "Додати / змінити",
  "No custom fields defined.": "Додаткових полів немає.",
  "Display on report": "Показувати при створенні",
  "Display on update": "Показувати при редагуванні",
  "Display on resolve": "Показувати при вирішенні",
  "Display on close": "Показувати при закритті",
  "Required on report": "Обов'язкове при створенні",
  "Required on update": "Обов'язкове при редагуванні",
  "Required on resolve": "Обов'язкове при вирішенні",
  "Required on close": "Обов'язкове при закритті",
  "Add to filters": "Додати до фільтрів",
  "New Custom Field": "Нове додаткове поле",
  "Possible values (a|b|c)": "Можливі значення (a|b|c)",
  "Default value": "Значення за замовчуванням",
  "Regular expression": "Регулярний вираз",
  "Read access": "Доступ на читання",
  "Write access": "Доступ на запис",
  "Min. length": "Мін. довжина",
  "Max. length": "Макс. довжина",
  "Linked projects": "Пов'язані проекти",
  "Possible values": "Можливі значення",
  "Delete custom field {name} and all its values?": "Видалити поле {name} разом з усіма значеннями?",
  "Rename team": "Перейменувати команду",
  "Joined": "Приєднався",
  "Last Visit": "Останній візит",
  "you": "ви",
  "Has not replaced the temporary password yet": "Ще не змінив тимчасовий пароль",
  "temporary password": "тимчасовий пароль",
  "Leave \"{team}\"?": "Вийти з «{team}»?",
  "Remove {user} from the team?": "Прибрати {user} з команди?",
  "Leave": "Вийти",
  "The access level applies to every project of the team; a project's members list can raise or lower it for that project. Administrators manage the team and its projects.": "Рівень доступу діє в усіх проектах команди; у списку учасників проекту його можна підвищити або знизити для цього проекту. Адміністратори керують командою та її проектами.",
  "Invite people": "Запросити людей",
  "name@company.com": "name@company.com",
  "Send invitation": "Надіслати запрошення",
  "Invitation sent to {email}. If the e-mail doesn't arrive, send them this link:": "Запрошення надіслано на {email}. Якщо лист не дійде, надішліть це посилання:",
  "Pending invitation": "Очікує запрошення",
  "Invited by": "Запросив",
  "Expires": "Діє до",
  "Revoke": "Відкликати",
  "Copied": "Скопійовано",
  "Copy": "Копіювати",
  "Back to projects": "Назад до проектів",
  "Other teams": "Інші команди",
  "Assigned to Me (Unresolved)": "Призначені мені (невирішені)",
  "Reported by Me": "Створені мною",
  "Resolved": "Вирішені",
  "Recently Modified": "Нещодавно змінені",
  "Monitored by Me": "За якими я стежу",
  "Nothing here.": "Тут порожньо.",
  "View all {n} →": "Переглянути всі ({n}) →",
  "has been reported.": "створено.",
  "Required fields are marked with an asterisk": "Обов'язкові поля позначено зірочкою",
  "Select a project": "Оберіть проект",
  "Issue type": "Тип задачі",
  "Component (category)": "Компонент (категорія)",
  "Select…": "Оберіть…",
  "global": "глобальна",
  "What happened? What did you expect?": "Що сталося? Чого ви очікували?",
  "Automatic / unassigned": "Автоматично / без виконавця",
  "Labels": "Мітки",
  "label1, label2": "мітка1, мітка2",
  "Affects version": "Стосується версії",
  "Fix version (target)": "Цільова версія",
  "Fewer fields": "Менше полів",
  "More fields (steps, environment, visibility)": "Більше полів (кроки, середовище, видимість)",
  "Steps to reproduce": "Кроки для відтворення",
  "Additional information": "Додаткова інформація",
  "Visibility": "Видимість",
  "Public": "Публічна",
  "Build": "Збірка",
  "OS version": "Версія ОС",
  "Report Stay (report another issue)": "Залишитися (створити ще одну задачу)",
  "Submitting…": "Надсилання…",
  "Submit Issue": "Створити задачу",
  "Report Issue (clone of {id})": "Створити задачу (копія {id})",
  "No unreleased versions with planned issues.": "Немає невипущених версій із запланованими задачами.",
  "(scheduled {date})": "(заплановано на {date})",
  "View issues": "Переглянути задачі",
  "{resolved} of {total} resolved": "вирішено {resolved} з {total}",
  "No released versions.": "Немає випущених версій.",
  "(released {date})": "(випущено {date})",
  "No issues.": "Задач немає.",
  "By Status": "За статусом",
  "By Severity": "За серйозністю",
  "open": "відкриті",
  "total": "усього",
  "By Project": "За проектом",
  "By Assignee": "За виконавцем",
  "resolved": "вирішена",
  "(unassigned)": "(без виконавця)",
  "Search teams": "Пошук команд",
  "You're not in a team yet. Create one below, or open the invitation link someone sent you.": "Ви ще не в команді. Створіть її нижче або відкрийте посилання-запрошення, яке вам надіслали.",
  "Open {team}": "Відкрити {team}",
  "More options": "Більше дій",
  "Open team": "Відкрити команду",
  "Members & invitations": "Учасники й запрошення",
  "Leave the team \"{team}\"? You lose access to its projects.": "Вийти з команди «{team}»? Ви втратите доступ до її проектів.",
  "Leave team": "Вийти з команди",
  "Create a team": "Створити команду",
  "e.g. Mobile squad": "напр. Мобільна команда",
  "Create team": "Створити команду",
  "new": "нова",
  "feedback": "зворотний зв'язок",
  "acknowledged": "визнана",
  "confirmed": "підтверджена",
  "assigned": "призначена",
  "none": "немає",
  "low": "низький",
  "normal": "нормальний",
  "high": "високий",
  "urgent": "терміновий",
  "immediate": "негайний",
  "feature": "побажання",
  "trivial": "дрібниця",
  "text": "текст",
  "tweak": "доопрацювання",
  "minor": "незначна",
  "major": "значна",
  "crash": "збій",
  "block": "блокер",
  "always": "завжди",
  "sometimes": "іноді",
  "random": "випадково",
  "have not tried": "не перевірялось",
  "unable to reproduce": "не вдається відтворити",
  "N/A": "н/д",
  "fixed": "виправлено",
  "reopened": "відкрито знову",
  "not fixable": "неможливо виправити",
  "duplicate": "дублікат",
  "no change required": "зміни не потрібні",
  "suspended": "відкладено",
  "minor fix": "невелике виправлення",
  "major rework": "значна переробка",
  "redesign": "перепроєктування",
  "< 1 day": "< 1 дня",
  "2-3 days": "2-3 дні",
  "< 1 week": "< 1 тижня",
  "< 1 month": "< 1 місяця",
  "> 1 month": "> 1 місяця",
  "viewer": "спостерігач",
  "reporter": "репортер",
  "updater": "редактор",
  "developer": "розробник",
  "manager": "менеджер",
  "administrator": "адміністратор",
  "development": "розробка",
  "release": "реліз",
  "stable": "стабільний",
  "obsolete": "застарілий",
  "duplicate of": "дублікат",
  "related to": "пов'язана з",
  "parent of": "батьківська для",
  "child of": "дочірня для",
  "has duplicate": "має дублікат",
  "String": "Рядок",
  "Numeric": "Ціле число",
  "Float": "Дробове число",
  "Enumeration": "Перелік",
  "Checkbox": "Прапорці",
  "Multiselection list": "Список із кількома варіантами",
  "Radio": "Перемикачі",
  "Textarea": "Багаторядковий текст",
  "won't fix": "не виправлятиметься",
  "Your account may be disabled or the username/password you entered is incorrect.": "Можливо, обліковий запис вимкнено або ім'я користувача чи пароль неправильні.",
  "Too many attempts. Please wait a few minutes and try again.": "Забагато спроб. Зачекайте кілька хвилин і спробуйте знову.",
  "That username is already taken.": "Це ім'я користувача вже зайняте.",
  "An account with this e-mail address already exists. Log in or reset your password.": "Обліковий запис із цим email уже існує. Увійдіть або скиньте пароль.",
  "Password must have at least 8 characters": "Пароль має містити щонайменше 8 символів",
  "Username must have at least 2 characters": "Ім'я користувача має містити щонайменше 2 символи",
  "Username may only contain letters, digits and . _ @ + -": "Ім'я користувача може містити лише літери, цифри та . _ @ + -",
  "Invalid e-mail address": "Неправильний email",
  "Team name is required": "Потрібна назва команди",
  "The current password is incorrect.": "Поточний пароль неправильний.",
  "The new password must be different from the current one.": "Новий пароль має відрізнятися від поточного.",
  "Another account already uses this e-mail address.": "Цей email уже використовує інший обліковий запис.",
  "This invitation is no longer valid. Ask for a new one.": "Запрошення більше не дійсне. Попросіть нове.",
  "This invitation link is not valid.": "Посилання-запрошення недійсне.",
  "This link has expired or was already used. Request a new one.": "Посилання прострочене або вже використане. Запросіть нове.",
  "Sign-up is by invitation only.": "Реєстрація лише за запрошенням.",
  "Please change your password first.": "Спершу змініть пароль.",
  "Not logged in": "Ви не увійшли",
  "Create or join a team first.": "Спершу створіть команду або приєднайтеся до неї.",
  "Team administrator access required.": "Потрібні права адміністратора команди.",
  "A team needs at least one administrator. Make someone else an administrator first.": "У команді має бути хоча б один адміністратор. Спершу призначте адміністратором когось іншого.",
  "This person is already in the team.": "Ця людина вже в команді.",
  "Only team members can be added to a project. Invite them to the team first.": "До проекту можна додати лише учасників команди. Спершу запросіть людину до команди.",
  "A project with this name already exists.": "Проект із такою назвою вже існує.",
  "Summary is required": "Потрібна назва",
  "Description is required": "Потрібен опис",
  "Category is required": "Потрібна категорія",
  "Internal server error": "Внутрішня помилка сервера",
  "Not found": "Не знайдено",
  "Access denied": "Доступ заборонено",
  "Open": "Відкриті",
  "Closed": "Закриті",
  "Total": "Усього",
  "{n} minutes ago": {"one": "{n} хвилину тому", "few": "{n} хвилини тому", "many": "{n} хвилин тому", "other": "{n} хвилин тому"},
  "{n} hours ago": {"one": "{n} годину тому", "few": "{n} години тому", "many": "{n} годин тому", "other": "{n} годин тому"},
  "{n} days ago": {"one": "{n} день тому", "few": "{n} дні тому", "many": "{n} днів тому", "other": "{n} днів тому"},
  "{n} members": {"one": "{n} учасник", "few": "{n} учасники", "many": "{n} учасників", "other": "{n} учасників"},
  "{n} issues updated.": {"one": "Оновлено {n} задачу.", "few": "Оновлено {n} задачі.", "many": "Оновлено {n} задач.", "other": "Оновлено {n} задач."},
  "Delete {n} issues permanently?": {"one": "Видалити {n} задачу назавжди?", "few": "Видалити {n} задачі назавжди?", "many": "Видалити {n} задач назавжди?", "other": "Видалити {n} задач назавжди?"},
  "{n} projects": {"one": "{n} проект", "few": "{n} проекти", "many": "{n} проектів", "other": "{n} проектів"},
  "{count} of {n} projects": {"one": "{count} з {n} проекту", "few": "{count} з {n} проектів", "many": "{count} з {n} проектів", "other": "{count} з {n} проектів"},
  "{n} days left": {"one": "залишився {n} день", "few": "залишилося {n} дні", "many": "залишилося {n} днів", "other": "залишилося {n} днів"},
  "{resolved} of {n} issues resolved": {"one": "вирішено {resolved} з {n} задачі", "few": "вирішено {resolved} з {n} задач", "many": "вирішено {resolved} з {n} задач", "other": "вирішено {resolved} з {n} задач"},
  "{n} issues": {"one": "{n} задача", "few": "{n} задачі", "many": "{n} задач", "other": "{n} задач"},
  "Import": "Імпорт",
  "API": "API",
  "Issue created": "Задачу створено",
  "Issue changed (status, assignee, fields)": "Задачу змінено (статус, виконавець, поля)",
  "Note added (public notes only)": "Додано нотатку (лише публічні)",
  "API keys": "API-ключі",
  "Key name, e.g. Ship": "Назва ключа, напр. Ship",
  "Read only": "Лише читання",
  "Create key": "Створити ключ",
  "Key \"{name}\" created. Copy it now — it is shown only once:": "Ключ «{name}» створено. Скопіюйте його зараз — він показується лише один раз:",
  "Requests with a key act as the person who created it, with their rights in this team. Revoke a key when it is no longer needed.": "Запити з ключем виконуються від імені того, хто його створив, з його правами в цій команді. Відкликайте ключі, які більше не потрібні.",
  "Access": "Доступ",
  "Created by": "Створив",
  "Created": "Створено",
  "Last used": "Востаннє використано",
  "read only": "лише читання",
  "read & write": "читання й запис",
  "revoked": "відкликано",
  "Revoke the key \"{name}\"? Programs using it stop working.": "Відкликати ключ «{name}»? Програми, що ним користуються, перестануть працювати.",
  "HTTP {status} in {ms} ms": "HTTP {status} за {ms} мс",
  "Webhooks (send issues to another system)": "Вебхуки (надсилання задач в іншу систему)",
  "New webhook": "Новий вебхук",
  "Test sent to \"{name}\": {result}": "Тест надіслано на «{name}»: {result}",
  "When an issue is created or changed, the server sends a POST request with JSON to the endpoint. Each request carries the header X-BugTracker-Signature: sha256=HMAC(secret, body), so the receiver can check that it came from here.": "Коли задачу створено або змінено, сервер надсилає на кінцеву точку POST-запит із JSON. Кожен запит має заголовок X-BugTracker-Signature: sha256=HMAC(secret, body), щоб отримувач міг перевірити, що він звідси.",
  "Endpoint": "Кінцева точка",
  "Events": "Події",
  "Last delivery": "Остання відправка",
  "Send test": "Надіслати тест",
  "Log": "Журнал",
  "Delete the webhook \"{name}\"?": "Видалити вебхук «{name}»?",
  "Webhook \"{name}\" saved. Its signing secret (for checking X-BugTracker-Signature):": "Вебхук «{name}» збережено. Його секрет підпису (для перевірки X-BugTracker-Signature):",
  "Done": "Готово",
  "Edit webhook": "Редагувати вебхук",
  "e.g. Ship": "напр. Ship",
  "API endpoint (URL)": "Кінцева точка API (URL)",
  "All projects": "Усі проекти",
  "Extra headers (one per line, e.g. Authorization: Bearer <key of the other system>)": "Додаткові заголовки (по одному на рядок, напр. Authorization: Bearer <ключ іншої системи>)",
  "JSON payload": "JSON Payload",
  "(empty = standard payload with the whole issue)": "(порожньо = стандартний payload з усією задачею)",
  "Placeholders: {{event}}, {{issue.id}}, {{issue.summary}}, {{issue.status}}, {{issue.project.name}}, {{issue.handler.username}}, {{issue.url}}, {{actor.username}}, {{note.text}}. {{name|json}} inserts a value as JSON, e.g. {{issue|json}} for the whole issue.": "Підстановки: {{event}}, {{issue.id}}, {{issue.summary}}, {{issue.status}}, {{issue.project.name}}, {{issue.handler.username}}, {{issue.url}}, {{actor.username}}, {{note.text}}. {{name|json}} вставляє значення як JSON, напр. {{issue|json}} — усю задачу.",
  "Insert example": "Вставити приклад",
  "Preview with the latest issue": "Попередній перегляд з останньою задачею",
  "Signing secret:": "Секрет підпису:",
  "Create a new secret? The receiver must be updated.": "Створити новий секрет? Отримувача треба буде оновити.",
  "New secret": "Новий секрет",
  "Deliveries of \"{name}\"": "Відправки «{name}»",
  "Nothing was sent yet.": "Ще нічого не надсилалось.",
  "Time": "Час",
  "Event": "Подія",
  "Issue": "Задача",
  "Result": "Результат",
  "Request": "Запит",
  "Response": "Відповідь",
  "the key: team, user, read-only": "ключ: команда, користувач, лише читання",
  "valid values for status, priority, severity, resolution …": "допустимі значення статусу, пріоритету, серйозності, рішення …",
  "projects of the team": "проекти команди",
  "categories, versions and custom fields of a project": "категорії, версії та додаткові поля проекту",
  "members of the team": "учасники команди",
  "issues; filters: project, status, priority, severity, handler, reporter, category, target_version, search, updated_since, include_closed, page, per_page (max 500), include=notes": "задачі; фільтри: project, status, priority, severity, handler, reporter, category, target_version, search, updated_since, include_closed, page, per_page (макс. 500), include=notes",
  "one issue with its notes": "одна задача з нотатками",
  "create an issue (JSON)": "створити задачу (JSON)",
  "change an issue; \"note\" adds a note at the same time": "змінити задачу; «note» одночасно додає нотатку",
  "add a note: {\"text\": \"...\", \"private\": false}": "додати нотатку: {\"text\": \"...\", \"private\": false}",
  "REST API": "REST API",
  "Base URL:": "Базова адреса:",
  "send the key as": "ключ надсилається як",
  "or": "або",
  "Values like status or priority can be given as names (\"high\") or Mantis numbers (40); projects, categories and people by name or id. The SOAP API for Mantis tools stays available at /api/soap/mantisconnect.php.": "Значення на кшталт статусу чи пріоритету можна передавати назвою («high») або числом Mantis (40); проекти, категорії та людей — назвою або id. SOAP API для інструментів Mantis лишається доступним за /api/soap/mantisconnect.php.",
  "The upload was interrupted.": "Завантаження перервано.",
  "Reading the dump": "Читання дампу",
  "Starting…": "Запуск…",
  "Big databases take a while (about 25 minutes for 20,000 issues). You can leave this page and come back later.": "Великі бази обробляються довго (приблизно 25 хвилин на 20 000 задач). Можна піти з цієї сторінки й повернутися пізніше.",
  "Importing": "Імпорт",
  "Everything is written in one step at the end; until then the team does not change.": "Усе записується одним кроком наприкінці; до того команда не змінюється.",
  "The last import failed: {error}": "Останній імпорт не вдався: {error}",
  "Import from Mantis": "Імпорт з Mantis",
  "Brings projects, issues with their numbers, notes, history, tags, relationships and people from a MantisBT database into this team. People can be matched with the members of the team; everyone else gets an account that keeps their Mantis password.": "Переносить проекти, задачі з їхніми номерами, нотатки, історію, теги, зв'язки й людей з бази MantisBT у цю команду. Людей можна зіставити з учасниками команди; решта отримає акаунти зі своїми паролями з Mantis.",
  "Mantis database dump (.sql or .sql.gz)": "Дамп бази Mantis (.sql або .sql.gz)",
  "Make the dump with mysqldump or the phpMyAdmin export (SQL format). The attachment folder can be chosen in the next step.": "Зробіть дамп через mysqldump або експорт phpMyAdmin (формат SQL). Папку з вкладеннями можна вибрати на наступному кроці.",
  "Uploading the dump": "Завантаження дампу",
  "Upload and read": "Завантажити й прочитати",
  "The import did not finish: {error}": "Імпорт не завершився: {error}",
  "What the dump contains": "Що є в дампі",
  "People": "Люди",
  "Choose who each Mantis user is in this team. \"New account\" creates an account with the Mantis username and password and adds it to the team.": "Вкажіть, ким є кожен користувач Mantis у цій команді. «Новий акаунт» створює акаунт з ім'ям і паролем з Mantis і додає його до команди.",
  "Mantis user": "Користувач Mantis",
  "In this team": "У цій команді",
  "disabled": "вимкнений",
  "New account": "Новий акаунт",
  "Start": "Запуск",
  "Import into this team": "Імпортувати в цю команду",
  "Cancel this import? The uploaded dump and files are deleted.": "Скасувати цей імпорт? Завантажений дамп і файли буде видалено.",
  "Cancel import": "Скасувати імпорт",
  "Attachments (optional)": "Вкладення (необов'язково)",
  "Mantis kept {n} attachment files on its server disk. Choose that upload folder to bring the files along; without it, the attachments are listed but their files are missing (they can be added with a new import later).": "Mantis зберігав {n} файлів вкладень на диску свого сервера. Виберіть цю папку, щоб перенести файли; без неї вкладення будуть у списку, але без файлів (їх можна додати пізніше новим імпортом).",
  "Files received: {received} of {needed}": "Отримано файлів: {received} з {needed}",
  "Mantis upload folder": "Папка вкладень Mantis",
  "{found} of the {all} files in the folder belong to this dump.": "{found} з {all} файлів у папці належать до цього дампу.",
  "Uploading files": "Завантаження файлів",
  "Notes": "Нотатки",
  "History entries": "Записи історії",
  "New projects": "Нові проекти",
  "Existing projects": "Наявні проекти",
  "New accounts": "Нові акаунти",
  "Matched people": "Зіставлені люди",
  "Attachment files": "Файли вкладень",
  "Replaced issues": "Замінені задачі",
  "Import finished": "Імпорт завершено",
  "\"{name}\" was imported into the team.": "«{name}» імпортовано в команду.",
  "Go to the issues": "До задач",
  "New accounts (they log in with their Mantis password):": "Нові акаунти (вхід із паролем з Mantis):",
  "{n} notes": {"one": "{n} нотатка", "few": "{n} нотатки", "many": "{n} нотаток", "other": "{n} нотаток"},
  "{n} people": {"one": "{n} людина", "few": "{n} людини", "many": "{n} людей", "other": "{n} людей"},
  "{n} attachments": {"one": "{n} вкладення", "few": "{n} вкладення", "many": "{n} вкладень", "other": "{n} вкладень"},
  "Replace {n} issues of this team that have the same numbers (their notes and history are replaced too)": {"one": "Замінити {n} задачу цієї команди з таким самим номером (її нотатки та історію теж буде замінено)", "few": "Замінити {n} задачі цієї команди з такими самими номерами (їхні нотатки та історію теж буде замінено)", "many": "Замінити {n} задач цієї команди з такими самими номерами (їхні нотатки та історію теж буде замінено)", "other": "Замінити {n} задач цієї команди з такими самими номерами (їхні нотатки та історію теж буде замінено)"},
  "Upload {n} files": {"one": "Завантажити {n} файл", "few": "Завантажити {n} файли", "many": "Завантажити {n} файлів", "other": "Завантажити {n} файлів"},
  "{n} warnings": {"one": "{n} попередження", "few": "{n} попередження", "many": "{n} попереджень", "other": "{n} попереджень"},
  "Give these issues new numbers; references like #123 in texts are updated. The list of new numbers can be downloaded after the import.": "Дати цим задачам нові номери; посилання на кшталт #123 у текстах буде оновлено. Список нових номерів можна завантажити після імпорту.",
  "Issues with new numbers": "Задачі з новими номерами",
  "Download the list of new issue numbers (CSV)": "Завантажити список нових номерів задач (CSV)",
  "{n} issue numbers of this dump are already used on this server.": {"one": "{n} номер задачі з цього дампу вже зайнятий на цьому сервері.", "few": "{n} номери задач з цього дампу вже зайняті на цьому сервері.", "many": "{n} номерів задач з цього дампу вже зайнято на цьому сервері.", "other": "{n} номерів задач з цього дампу вже зайнято на цьому сервері."},
  "The {n} issues whose numbers other teams use get new numbers.": {"one": "{n} задача, номер якої використовує інша команда, отримає новий номер.", "few": "{n} задачі, номери яких використовують інші команди, отримають нові номери.", "many": "{n} задач, номери яких використовують інші команди, отримають нові номери.", "other": "{n} задач, номери яких використовують інші команди, отримають нові номери."},
  "Type {name} to confirm": "Щоб підтвердити, введіть {name}",
  "Your password": "Ваш пароль",
  "Delete project": "Видалити проект",
  "Export team data": "Експорт даних команди",
  "Downloads everything of the team as a .tar.gz archive: members, projects, issues with notes, history and relationships (JSON), and optionally the attachment files. Windows, macOS and 7-Zip open it.": "Завантажує всі дані команди архівом .tar.gz: учасників, проекти, задачі з нотатками, історією та зв'язками (JSON), а за бажанням і файли вкладень. Його відкривають Windows, macOS і 7-Zip.",
  "Include attachment files (can be large)": "Додати файли вкладень (архів може бути великим)",
  "Download export": "Завантажити експорт",
  "Delete team": "Видалити команду",
  "Delete account": "Видалення облікового запису",
  "Delete my account": "Видалити мій обліковий запис",
  "Removes your name, e-mail address, password and memberships. Issues and notes you wrote stay in their teams and show \"Deleted user\". This cannot be undone.": "Видаляє ваше ім'я, email, пароль і членство в командах. Задачі й нотатки, які ви написали, залишаться в командах з автором «Deleted user». Скасувати це не можна.",
  "You are the only member of {teams}; deleting your account deletes these teams with all their projects and issues.": "Ви єдиний учасник {teams}; разом з обліковим записом буде видалено ці команди з усіма проектами й задачами.",
  "You are the only administrator of {teams}. Make another member an administrator (Manage → Team) or delete the team first.": "Ви єдиний адміністратор {teams}. Спершу призначте адміністратором іншого учасника (Керування → Команда) або видаліть команду.",
  "Type the name of the team to confirm.": "Щоб підтвердити, введіть назву команди.",
  "The password is incorrect.": "Неправильний пароль.",
  "Type the name of the project to confirm.": "Щоб підтвердити, введіть назву проекту.",
  "This project has subprojects. Delete them or move them to another project first.": "У цього проекту є підпроекти. Спершу видаліть їх або перенесіть до іншого проекту.",
  "An import into this team is running. Wait for it to finish or cancel it first.": "Зараз триває імпорт у цю команду. Дочекайтеся завершення або спершу скасуйте його.",
  "Deletes the project with its {n} issues, their notes, history and attachments. This cannot be undone.": {"one": "Видаляє проект з його {n} задачею, її нотатками, історією та вкладеннями. Скасувати це не можна.", "few": "Видаляє проект з його {n} задачами, їхніми нотатками, історією та вкладеннями. Скасувати це не можна.", "many": "Видаляє проект з його {n} задачами, їхніми нотатками, історією та вкладеннями. Скасувати це не можна.", "other": "Видаляє проект з його {n} задачами, їхніми нотатками, історією та вкладеннями. Скасувати це не можна."},
  "Deletes the team with its {n} projects, all issues and files, API keys and webhooks. Members lose access; their accounts stay. This cannot be undone, so export the data first if you may need it.": {"one": "Видаляє команду з її {n} проектом, усіма задачами й файлами, API-ключами та вебхуками. Учасники втратять доступ, але їхні облікові записи залишаться. Скасувати це не можна, тож спершу експортуйте дані, якщо вони можуть знадобитися.", "few": "Видаляє команду з її {n} проектами, усіма задачами й файлами, API-ключами та вебхуками. Учасники втратять доступ, але їхні облікові записи залишаться. Скасувати це не можна, тож спершу експортуйте дані, якщо вони можуть знадобитися.", "many": "Видаляє команду з її {n} проектами, усіма задачами й файлами, API-ключами та вебхуками. Учасники втратять доступ, але їхні облікові записи залишаться. Скасувати це не можна, тож спершу експортуйте дані, якщо вони можуть знадобитися.", "other": "Видаляє команду з її {n} проектами, усіма задачами й файлами, API-ключами та вебхуками. Учасники втратять доступ, але їхні облікові записи залишаться. Скасувати це не можна, тож спершу експортуйте дані, якщо вони можуть знадобитися."},
  "A NEW issue has been reported by {user}.": "{user} створив НОВУ задачу.",
  "The issue has been ASSIGNED by {user}.": "{user} ПРИЗНАЧИВ задачу.",
  "The status of the issue changed from {from} to {to} (by {user}).": "Статус задачі змінено з {from} на {to} (змінив {user}).",
  "A NOTE has been added to this issue by {user}.": "{user} додав НОТАТКУ до цієї задачі.",
  "The priority of the issue was changed by {user}.": "{user} змінив пріоритет задачі.",
  "The issue has been UPDATED by {user} ({fields}).": "{user} ЗМІНИВ задачу ({fields}).",
  "A relationship to issue #{id} was added (by {user}).": "Додано зв'язок із задачею #{id} (додав {user}).",
  "Issue ID": "Номер задачі",
  "(note by {user})": "(нотатка від {user})",
  "Reset your {app} password": "Скидання пароля {app}",
  "Hello {user},": "Вітаємо, {user}!",
  "open this link to choose a new password (valid for 1 hour):": "відкрийте це посилання, щоб вибрати новий пароль (діє 1 годину):",
  "If you didn't ask for this, ignore this e-mail.": "Якщо ви цього не просили, просто проігноруйте цей лист.",
  "{user} sent you a reminder regarding this issue:": "{user} надіслав вам нагадування щодо цієї задачі:",
  "{user} invited you to the team \"{team}\" on {app}": "{user} запрошує вас до команди «{team}» у {app}",
  "{user} invited you to join the team \"{team}\" on {app}.": "{user} запрошує вас приєднатися до команди «{team}» у {app}.",
  "Hello,": "Вітаємо!",
  "Accept the invitation (valid for {n} days):": {"one": "Прийняти запрошення (діє {n} день):", "few": "Прийняти запрошення (діє {n} дні):", "many": "Прийняти запрошення (діє {n} днів):", "other": "Прийняти запрошення (діє {n} днів):"},
  "Confirm your e-mail address for {app}": "Підтвердіть email для {app}",
  "please confirm your e-mail address by opening this link (valid for 7 days):": "підтвердіть свій email, відкривши це посилання (діє 7 днів):",
  "If you didn't create an account, ignore this e-mail.": "Якщо ви не створювали обліковий запис, просто проігноруйте цей лист.",
  "Add an e-mail address to your account first.": "Спершу додайте email до облікового запису.",
  "Your e-mail address is already confirmed.": "Ваш email уже підтверджено.",
  "Too many e-mails. Please wait an hour and try again.": "Забагато листів. Зачекайте годину й спробуйте знову.",
  "This link is for an e-mail address the account no longer uses.": "Це посилання для email, який обліковий запис більше не використовує.",
  "Confirm your e-mail address before inviting people. The link is in the e-mail we sent you.": "Підтвердіть email, перш ніж запрошувати людей. Посилання є в листі, який ми вам надіслали.",
  "Please confirm your e-mail address {email}: open the link in the e-mail we sent you.": "Підтвердіть свій email {email}: відкрийте посилання з листа, який ми вам надіслали.",
  "Sent. Check your inbox.": "Надіслано. Перевірте пошту.",
  "Send the link again": "Надіслати посилання ще раз",
  "Confirm e-mail address": "Підтвердження email",
  "Thank you, your e-mail address is confirmed.": "Дякуємо, ваш email підтверджено.",
  "Continue": "Продовжити",
  "Account updated. We sent a link to the new e-mail address to confirm it.": "Обліковий запис оновлено. Ми надіслали посилання на новий email, щоб його підтвердити.",
  "Create a project": "Створіть проект",
  "Projects hold the issues, with their own categories and versions.": "У проектах живуть задачі, з власними категоріями та версіями.",
  "Report the first issue": "Створіть першу задачу",
  "A bug, a task or an idea: anything the team should work on.": "Помилка, завдання чи ідея: усе, над чим має працювати команда.",
  "Invite your team": "Запросіть команду",
  "Colleagues get an e-mail with a link to join.": "Колеги отримають лист із посиланням, щоб приєднатися.",
  "Bring your data and tools": "Перенесіть дані й підключіть інструменти",
  "Import a Mantis database, or connect other tools with an API key or webhooks.": "Імпортуйте базу Mantis або підключіть інші інструменти через API-ключ чи вебхуки.",
  "Get started with {team}": "Перші кроки з {team}",
  "{done} of {total} done": "Виконано {done} з {total}",
  "Hide": "Сховати",
  "Just looking around?": "Просто хочете роздивитися?",
  "Create a sample project with example issues": "Створіть приклад проекту з прикладами задач",
  "(you can delete it later)": "(його можна буде видалити)",
  "Sample project": "Приклад проекту",
  "Example issues to try things out. Delete this project when you no longer need it.": "Приклади задач, щоб усе спробувати. Видаліть цей проект, коли він стане не потрібен.",
  "General": "Загальне",
  "The \"Log in\" button does nothing on phones": "Кнопка «Увійти» не працює на телефонах",
  "Open the site on a phone and tap \"Log in\": nothing happens. On a computer it works.": "Відкрийте сайт на телефоні й натисніть «Увійти»: нічого не відбувається. На комп'ютері працює.",
  "Add a dark mode": "Додати темну тему",
  "Several users work in the evening and asked for a dark theme.": "Кілька користувачів працюють увечері й просять темну тему.",
  "Typo on the login page": "Друкарська помилка на сторінці входу",
  "\"Montly\" should be \"Monthly\".": "«Щомісяно» має бути «Щомісячно».",
  "I will fix it with the next update.": "Виправлю в наступному оновленні.",
  "Exporting the report takes a long time": "Експорт звіту триває довго",
  "Exporting the monthly report takes about two minutes.": "Експорт місячного звіту триває близько двох хвилин.",
  "How many rows does your report have?": "Скільки рядків у вашому звіті?",
  "The app crashes when an empty form is saved": "Застосунок падає, якщо зберегти порожню форму",
  "Open a new form, leave all fields empty and click \"Save\".": "Відкрийте нову форму, залиште всі поля порожніми й натисніть «Зберегти».",
  "Fixed: an empty form now shows a message instead.": "Виправлено: тепер для порожньої форми з'являється повідомлення.",
  "Notifications": "Сповіщення",
  "Mark all as read": "Позначити всі як прочитані",
  "No notifications yet.": "Сповіщень поки немає.",
  "Someone": "Хтось",
  "{user} mentioned you": "{user} згадав вас",
  "{user} reported a new issue": "{user} створив нову задачу",
  "{user} assigned the issue to you": "{user} призначив задачу вам",
  "{user} assigned the issue to {handler}": "{user} призначив задачу на {handler}",
  "{user} changed the status to {status}": "{user} змінив статус на «{status}»",
  "{user} added a note": "{user} додав нотатку",
  "{user} changed the priority": "{user} змінив пріоритет",
  "{user} added a relationship": "{user} додав зв'язок",
  "{user} updated the issue": "{user} змінив задачу",
  "{user} mentioned you:": "{user} згадав вас:",
  "Bold": "Жирний",
  "bold text": "жирний текст",
  "Italic": "Курсив",
  "italic text": "текст курсивом",
  "Code": "Код",
  "Link": "Посилання",
  "Numbered list": "Нумерований список",
  "Quote": "Цитата",
  "Write": "Текст",
  "Preview": "Попередній перегляд",
  "Nothing to preview.": "Немає що показати.",
  "Copy as Markdown, to show the image in a text": "Скопіювати як Markdown, щоб показати зображення в тексті",
  "Git (GitHub, GitLab)": "Git (GitHub, GitLab)",
  "Name, e.g. GitHub app": "Назва, напр. GitHub app",
  "Create webhook": "Створити вебхук",
  "Commits that mention #123 add a note to issue 123; \"fixes #123\" (or closes, resolves) also resolves it. Notes are written in the name of the person who creates the webhook.": "Коміти, що згадують #123, додають нотатку до задачі 123; «fixes #123» (або closes, resolves) ще й вирішує її. Нотатки пишуться від імені того, хто створив вебхук.",
  "Webhook \"{name}\" created. Copy the address and the secret now — they are shown only once.": "Вебхук «{name}» створено. Скопіюйте адресу й секрет зараз — їх показано лише один раз.",
  "Payload URL": "Адреса (Payload URL)",
  "Secret": "Секрет",
  "GitHub: repository → Settings → Webhooks → Add webhook; content type application/json, the secret as \"Secret\", event \"Just the push event\".": "GitHub: репозиторій → Settings → Webhooks → Add webhook; content type application/json, секрет у полі «Secret», подія «Just the push event».",
  "GitLab: project → Settings → Webhooks; the address as URL, the secret as \"Secret token\", trigger \"Push events\".": "GitLab: проект → Settings → Webhooks; адреса в полі URL, секрет у полі «Secret token», тригер «Push events».",
  "Notes as": "Нотатки від",
  "Resolve on \"fixes #N\"": "Вирішувати на «fixes #N»",
  "Telegram groups": "Групи в Telegram",
  "Connect a group": "Підключити групу",
  "A connected group gets new issues, changes and public notes of this team.": "Підключена група отримує нові задачі, зміни та публічні нотатки цієї команди.",
  "Add {bot} to the group, then send this message in the group (valid for an hour):": "Додайте {bot} до групи, потім надішліть у групі це повідомлення (діє годину):",
  "the bot": "бота",
  "(group without a name)": "(група без назви)",
  "Disconnect": "Від'єднати",
  "Telegram": "Telegram",
  "Your notifications also come to Telegram.": "Ваші сповіщення також надходять у Telegram.",
  "Get the notifications of the bell in a chat with our Telegram bot.": "Отримуйте сповіщення з дзвіночка в чаті з нашим Telegram-ботом.",
  "Connect Telegram": "Підключити Telegram",
  "Telegram opens; press \"Start\" in the chat. If it did not open:": "Відкриється Telegram; натисніть «Start» у чаті. Якщо не відкрився:",
  "Check again": "Перевірити ще раз",
  "Notifications stopped.": "Сповіщення вимкнено.",
  "Hello! Connect your account on the website: My Account → Telegram.": "Вітаємо! Підключіть свій обліковий запис на сайті: Мій обліковий запис → Telegram.",
  "This code is not valid any more. Create a new one on the website.": "Цей код більше не дійсний. Створіть новий на сайті.",
  "Open the link from your account page in a private chat with the bot.": "Відкрийте посилання зі сторінки облікового запису в особистому чаті з ботом.",
  "Connected: your {app} notifications come here now. Send /stop to end them.": "Підключено: тепер сповіщення {app} надходитимуть сюди. Надішліть /stop, щоб їх вимкнути.",
  "Add the bot to a group and send the command there.": "Додайте бота до групи й надішліть команду там.",
  "This chat now gets the updates of the team \"{team}\". Send /stop to end them.": "Цей чат тепер отримує оновлення команди «{team}». Надішліть /stop, щоб їх вимкнути.",
  "Open the issue": "Відкрити задачу",
  "Telegram is not set up on this server.": "Telegram на цьому сервері не налаштовано.",
  "Terms of Service": "Умови використання",
  "Privacy Policy": "Політика конфіденційності",
  "Imprint": "Вихідні дані",
  "Not available": "Недоступно",
  "This page has not been set up yet.": "Цю сторінку ще не налаштовано.",
  "By creating an account you agree to the": "Створюючи обліковий запис, ви погоджуєтеся з",
  "and the": "та",
  "Site administration": "Адміністрування сайту",
  "Users": "Користувачі",
  "New in 7 days": "Нових за 7 днів",
  "New in 30 days": "Нових за 30 днів",
  "Active in 7 days": "Активних за 7 днів",
  "Files": "Файли",
  "Owner": "Власник",
  "Members": "Учасники",
  "operator": "оператор",
  "not confirmed": "не підтверджено",
  "Disable {user}? They are logged out and cannot log in.": "Вимкнути {user}? Користувача буде виведено з системи, і він не зможе увійти.",
  "Disable": "Вимкнути",
  "Enable": "Увімкнути",
  "Site operator access required.": "Потрібен доступ оператора сайту.",
  "You cannot disable your own account.": "Не можна вимкнути власний обліковий запис.",
  "Text color": "Колір тексту",
  "Underline": "Підкреслений",
  "Strikethrough": "Закреслений",
  "Highlight": "Виділення кольором",
  "Text size": "Розмір тексту",
  "Small": "Дрібний",
  "Heading": "Заголовок",
  "Heading {n}": "Заголовок {n}",
  "Alignment": "Вирівнювання",
  "Left": "Ліворуч",
  "Center": "По центру",
  "Right": "Праворуч",
  "Justify": "По ширині",
  "Image": "Зображення",
  "Lettered list": "Список з літерами",
  "List item": "Пункт списку",
  "Table": "Таблиця",
  "Horizontal line": "Горизонтальна лінія",
  "More": "Більше",
  "Subscript": "Нижній індекс",
  "Superscript": "Верхній індекс",
  "Code block": "Блок коду",
  "plain text": "звичайний текст",
  "How the text is written": "Як написано текст",
  "Auto": "Авто",
  "Text": "Текст",
  "Image preview": "Перегляд зображення",
  "Preview image": "Переглянути зображення",
  "Preview {file}": "Переглянути {file}",
  "Download {file}": "Завантажити {file}",
  "Download": "Завантажити",
  "Previous image": "Попереднє зображення",
  "Next image": "Наступне зображення",
  "Actual size": "Оригінальний розмір",
  "Fit to screen": "За розміром екрана",
  "Loading image…": "Завантаження зображення…",
  "Could not load this image. You can still download the file.": "Не вдалося відкрити зображення. Ви можете завантажити файл.",
  "Application updates": "Оновлення застосунку",
  "Fetch the latest main branch, build an isolated release, then restart this application. The page reloads when the new server is ready.": "Завантажити актуальну гілку main, зібрати окремий реліз і перезапустити застосунок. Сторінка оновиться, коли сервер буде готовий.",
  "Back up the database before updating. Commit and push local changes before using this button.": "Перед оновленням зробіть резервну копію бази даних. Збережіть локальні зміни комітом і надішліть їх у репозиторій.",
  "The update did not finish in time. Check the server update logs before retrying.": "Оновлення не завершилося вчасно. Перед повторною спробою перевірте журнали оновлення сервера.",
  "The application updater must be installed and enabled on this server first.": "Спочатку встановіть і ввімкніть службу оновлення застосунку на цьому сервері.",
  "Application update completed.": "Застосунок оновлено.",
  "Update requested. Waiting for the updated server; a brief connection interruption is expected.": "Запит на оновлення надіслано. Очікуємо перезапуску сервера; можливий короткий розрив з’єднання.",
  "Build and restart the Böning application from origin/main?": "Зібрати й перезапустити застосунок Böning з origin/main?",
  "Updating…": "Оновлення…",
  "Update from Git and restart": "Оновити з Git і перезапустити",
  "Fetching origin/main and checking the deployment checkout.": "Завантаження origin/main і перевірка робочої копії.",
  "Building the fetched revision in an isolated release directory.": "Збірка завантаженої версії в окремій папці релізу.",
  "Build succeeded. Restarting the application.": "Збірка успішна. Перезапуск застосунку.",
  "Attachment previews": "Попередній перегляд вкладень",
  "Maximum preview size": "Максимальний розмір перегляду",
  "Images and video players fit within this size without cropping. Smaller screens limit the width automatically.": "Зображення й відеопрогравачі вписуються в цей розмір без обрізання. На менших екранах ширина обмежується автоматично.",
  "Example — changes immediately": "Приклад — змінюється одразу",
  "Example attachment preview": "Приклад перегляду вкладення",
  "Performance overview": "Огляд продуктивності",
  "Save your preferences to use this size on issue attachments.": "Збережіть налаштування, щоб застосувати цей розмір до вкладень у задачах.",
  "Preview video": "Переглянути відео",
  "Play video": "Відтворити відео",
  "Play {file}": "Відтворити {file}",
  "Video preview: {file}": "Перегляд відео: {file}",
  "Hide video": "Приховати відео",
  "This video could not be played in your browser. Download it to watch it in another player.": "Це відео не вдалося відтворити у браузері. Завантажте його для перегляду в іншому програвачі.",
  "Effort & complexity": "Трудомісткість і складність",
  "Complexity / Story points": "Складність / Story points",
  "Story points": "Story points",
  "Not set": "Не задано",
  "Not rated": "Без оцінки",
  "Estimated time": "Оцінений час",
  "Estimated time (HH:MM)": "Оцінений час (ГГ:ХХ)",
  "Needed time (actual)": "Витрачений час (фактичний)",
  "Needed time (actual, HH:MM)": "Витрачений час (фактичний, ГГ:ХХ)",
  "From time entries": "Із записів часу",
  "Manual total": "Задано вручну",
  "Auto: {time}": "Автоматично: {time}",
  "Leave blank to use logged time. A manual total replaces it; the two are never added together.": "Залиште порожнім, щоб використати записи часу. Ручна сума замінює їх, а не додається до них.",
  "Story points describe complexity, not hours. Estimates are optional and can change as you learn.": "Story points описують складність, а не години. Оцінки необов’язкові й можуть змінюватися з новими знаннями.",
  "Estimation scale and meaning": "Шкала оцінювання та її значення",
  "Enter effort as H:MM or decimal hours.": "Введіть час як Г:ХХ або десяткову кількість годин.",
  "Project effort overview": "Трудомісткість проєктів",
  "Totals include only issues and time entries you can access. Coffee and question-mark estimates are counted separately from numeric points.": "Суми враховують лише доступні вам задачі й записи часу. Кавові чашки та знаки питання підраховуються окремо від числових балів.",
  "{count} issues need refinement, research or a planning pause.": "Для {count} задач потрібне уточнення, дослідження або пауза в плануванні.",
  "No effort": "Без зусиль",
  "Already complete or virtually no work.": "Уже виконано або майже не потребує роботи.",
  "Very small & trivial": "Дуже мала й проста",
  "A familiar, simple task with no unknowns. A useful reference story.": "Знайома проста задача без невідомих. Зручна еталонна історія.",
  "Small & routine": "Мала й типова",
  "A little more work, with clear requirements and a familiar solution.": "Трохи більше роботи, з чіткими вимогами й відомим рішенням.",
  "Medium": "Середня",
  "A normal, well-defined story with moderate work and a clear approach.": "Звичайна чітко визначена історія з помірним обсягом роботи та зрозумілим підходом.",
  "Large": "Велика",
  "Noticeable effort, with some complexity, unknowns or dependencies.": "Помітні зусилля, певна складність, невідомі або залежності.",
  "Very large & complex": "Дуже велика й складна",
  "Significant complexity or risk. The largest story to plan into one sprint.": "Значна складність або ризик. Найбільша історія, яку варто брати в один спринт.",
  "Epic — split before a sprint": "Епік — розділити до спринту",
  "Too large or uncertain for one sprint. Break it into smaller stories.": "Завелика або надто невизначена для одного спринту. Розділіть на менші історії.",
  "Huge": "Величезна",
  "A whole feature or module that needs more design and refinement.": "Ціла функція або модуль, що потребує додаткового проєктування й уточнення.",
  "Huge / incomplete": "Величезна / неповна",
  "A large area of work with fundamental decisions still missing.": "Великий обсяг роботи, для якого ще бракує основних рішень.",
  "Complete unknown": "Повна невідомість",
  "Start with research or a spike to understand the problem.": "Почніть із дослідження або спайка, щоб зрозуміти проблему.",
  "Break needed": "Потрібна перерва",
  "A planning-poker pause. This is not a numeric estimate.": "Пауза в покері планування. Це не числова оцінка.",
  "Needs clarification": "Потрібне уточнення",
  "Requirements or important information are missing. This is not a numeric estimate.": "Бракує вимог або важливої інформації. Це не числова оцінка.",
  "Preparing a compatible video preview…": "Готуємо сумісний відеоперегляд…",
  "Download original": "Завантажити оригінал",
  "Drag to change the order": "Перетягніть, щоб змінити порядок",
  "You cannot change the order of notes.": "Ви не можете змінювати порядок нотаток.",
  "You cannot change the order of attachments.": "Ви не можете змінювати порядок вкладень.",
  "The target note is not part of this issue.": "Цільова нотатка не належить до цієї задачі.",
  "Files can only be reordered within the same list.": "Порядок файлів можна змінювати лише в межах одного списку.",
  "Calculate from status history (confirmed → resolved)": "Обчислити з історії статусів (підтверджено → вирішено)",
  "Needed time from the status history": "Витрачений час з історії статусів",
  "Calendar time": "Календарний час",
  "This is how long the issue was open, not the working time. Change it if needed.": "Це час, протягом якого задача була відкрита, а не робочий час. За потреби змініть його.",
  "Use this time": "Використати цей час",
  "{days} d {time} h": "{days} д. {time} год.",
  "{time} h": "{time} год.",
  "or paste a screenshot, or drop files on the form": "або вставте знімок екрана чи перетягніть файли на форму",
  "Projects overview": "Огляд проєктів",
  "Project activities": "Активність проєктів",
  "Recent activities": "Остання активність",
  "Active target versions": "Активні цільові версії",
  "Activity in the last": "Активність за останні",
  "Added issues": "Додані задачі",
  "An issue resolved or closed more than once counts once, at the last time. Story points and needed time belong to the period in which the issue was resolved.": "Задача, вирішена або закрита кілька разів, рахується один раз — за останнім разом. Story points і витрачений час рахуються в періоді, коли задачу вирішено.",
  "Changes": "Зміни",
  "Changes in the last {n} weeks": "Зміни за останні тижні: {n}",
  "Day": "День",
  "Week": "Тиждень",
  "Month": "Місяць",
  "Year": "Рік",
  "Finished (resolved)": "Завершені (вирішені)",
  "Tested (closed)": "Перевірені (закриті)",
  "From": "Від",
  "To": "До",
  "Per": "За",
  "Period": "Період",
  "Progress": "Прогрес",
  "Involved projects": "Задіяні проєкти",
  "Involved users": "Задіяні користувачі",
  "Issues that became closed": "Задачі, які було закрито",
  "Issues that became resolved": "Задачі, які було вирішено",
  "Last activity": "Остання активність",
  "Needed time": "Витрачений час",
  "Needed time of the issues resolved in the period": "Витрачений час задач, вирішених у цьому періоді",
  "Story points (done / open)": "Story points (готово / відкрито)",
  "Story points of resolved issues / of open issues": "Story points вирішених / відкритих задач",
  "Story points of the issues resolved in the period": "Story points задач, вирішених у цьому періоді",
  "There are no active target versions.": "Немає активних цільових версій.",
  "Week of {date}": "Тиждень з {date}",
  "{done} of {total} resolved ({pct}%)": "{done} з {total} вирішено ({pct}%)",
  "{n} not estimated": "{n} без оцінки",
  "The start must be before the end.": "Початок має бути раніше за кінець.",
  "Too many rows: choose a larger time unit or a shorter range.": "Забагато рядків: виберіть більшу одиницю часу або коротший період.",
  "{n} weeks": {"one": "{n} тиждень", "few": "{n} тижні", "many": "{n} тижнів", "other": "{n} тижня"},
  "Note by {user}": "Нотатка від {user}",
  "You receive this e-mail because you take part in this issue.": "Ви отримали цей лист, бо берете участь у цьому записі.",
  "E-mail settings": "Налаштування e-mail",
  "Planned target versions": "Заплановані цільові версії",
  "Only issues planned for a target version that is not released yet are counted.": "Враховуються лише записи з цільовою версією, яку ще не випущено.",
  "Previous page": "Попередня сторінка",
  "Next page": "Наступна сторінка"
};

export default dict;
